<template>
  <v-container>
    <v-card>
      <v-card-title class="d-flex flex-wrap align-center gap-3">
        <span>Reporte de Ingresos</span>
        <v-spacer></v-spacer>
        <div class="d-flex flex-wrap gap-3">
          <v-text-field v-model="fechaInicio" type="date" label="Desde" density="compact" hide-details
            style="min-width: 160px" />
          <v-text-field v-model="fechaFin" type="date" label="Hasta" density="compact" hide-details
            style="min-width: 160px" />
          <v-btn color="primary" :loading="loading" @click="cargar">Actualizar</v-btn>
          <v-btn color="error" variant="tonal" prepend-icon="mdi-file-pdf-box" @click="exportarPdf">PDF</v-btn>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-alert v-if="errorRango" type="warning" variant="tonal" density="compact" class="mb-4">
          {{ errorRango }}
        </v-alert>
        <v-row class="mb-4">
          <v-col cols="12" md="6">
            <v-card variant="tonal" color="primary">
              <v-card-title class="text-subtitle-1">Total ingresos</v-card-title>
              <v-card-text class="text-h5 font-weight-bold">
                {{ formatCurrency(ingresos.total) }}
              </v-card-text>
              <v-card-subtitle class="text-caption text-medium-emphasis">
                {{ ingresos.cantidad }} {{ ingresos.cantidad === 1 ? 'movimiento' : 'movimientos' }}
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
        <v-data-table :headers="headers" :items="ingresos.movimientos" item-key="id"
          :sort-by="[{ key: 'fecha', order: 'asc' }]" density="comfortable">
          <template v-slot:[`item.fecha`]="{ item }">
            {{ moment(item.fecha).format('DD/MM/YYYY') }}
          </template>
          <template v-slot:[`item.monto`]="{ item }">
            <v-chip color="primary" size="small">{{ formatCurrency(item.monto) }}</v-chip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showPdfDialog" fullscreen persistent transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click="showPdfDialog = false"><v-icon>mdi-close</v-icon></v-btn>
          <v-toolbar-title>Reporte de Ingresos</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0" style="height: 100%;">
          <iframe v-if="pdfUrl" :src="pdfUrl" style="width: 100%; height: calc(100vh - 64px); border: none;"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    const today = new Date();
    const inicioMes = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      moment,
      loading: false,
      showPdfDialog: false,
      pdfUrl: '',
      errorRango: '',
      fechaInicio: this.formatDate(inicioMes),
      fechaFin: this.formatDate(today),
      headers: [
        { title: 'Fecha', value: 'fecha' },
        { title: 'Alumno', value: 'alumno' },
        { title: 'Curso', value: 'curso' },
        { title: 'Monto', value: 'monto' },
      ],
    };
  },
  computed: {
    ...mapGetters('reporte', ['ingresos']),
  },
  created() {
    this.cargar();
  },
  methods: {
    ...mapActions('reporte', ['fetchIngresos']),
    formatDate(d) {
      return d.toISOString().slice(0, 10);
    },
    formatCurrency(v) {
      return Number(v || 0).toLocaleString('es-PE', { style: 'currency', currency: 'PEN' });
    },
    async cargar() {
      if (!this.fechaInicio || !this.fechaFin) {
        this.errorRango =
          'Selecciona un rango de fechas válido. Verifica que el día exista (por ejemplo, junio termina el 30, no el 31).';
        return;
      }
      this.errorRango = '';
      this.loading = true;
      try {
        await this.fetchIngresos({
          fecha_inicio: this.fechaInicio,
          fecha_fin: this.fechaFin,
        });
      } finally {
        this.loading = false;
      }
    },
    exportarPdf() {
      const params = new URLSearchParams();
      if (this.fechaInicio) params.append('fecha_inicio', this.fechaInicio);
      if (this.fechaFin) params.append('fecha_fin', this.fechaFin);
      const qs = params.toString();
      const base = (axios.defaults.baseURL || '').replace(/\/$/, '');
      this.pdfUrl = `${base}/api/reporte/ingresos/pdf${qs ? `?${qs}` : ''}`;
      this.showPdfDialog = true;
    },
  },
};
</script>

<style scoped>
.gap-3 { gap: 12px; }
</style>
